import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";
import { Button, Image } from "react-bootstrap";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import Layout from "components/sales/layout/layout";
import GSTDetails from "components/sales/formSection/GSTDetails/gstDetails";
// import ParkingRules from "components/sales/formSection/parkingRules/parkingRules";

// import DummyAdd from "components/sales/formSection/gateDetails/dummyAdd";
import Commercial from "components/sales/formSection/commercial/commercial";
import Installation from 'components/sales/formSection/commercial/installation';
import Milestone from 'components/sales/formSection/mileStone/mileStone';
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import DivLayout from 'components/sales/divLayout/divLayout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';



const AddInvoiceNumber = (props) => {
  const {
    history,
    contractApartment,
    contractCorporate,
    contractSupply,
    contractAptData,
    contractCorpData,
    contractSupplyData,
    pincodeData,
    locationPinCode,
    postInvoiceNumber,
    documentUploadUrl,
    documentUrlData,
    match,
    getMaterial,
    getMateriaById,
    imageUploadUrl,
    videoUploadUrl,
    supplyNameFun,
    splNameData,
    shipTolocationPinCode,
    shipToPincodeData,
    clientBillingPocData,
    clientBillingAddress
  } = props;
  const { params } = match;
//   console.log(params);
  const postDataInputs = {
    commercial: null,
    gSTDetails: null,
    shippedTo: null,
    // billedTo: null,
    // clientData: null,
    otherDetails: null,
    gateDetails: null,
    // category: [],
    materialHardwares: null,
    tags:[],
    installation: null,
  };
//   const {prerequisiteData} = contractAptData;

  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [showAgreementDetarentalInvoiceils, setShowAgreementDetails] = useState(false);
  const [rentalInvoice, setRentalInvoice] = useState(null);
  const [isGateDetailsChanged, setIsGateDetailsChanged] = useState(false);
  const [contractData, setContractData] = useState({});


  const handleModalHide = () => {
    history.push(`${baseUrl}/postSalesListing`);
    setIsModal(false);
  };

 

  const handleSubmit = (id) => {
    if(rentalInvoice === null || rentalInvoice === ''){
      toast.error('Please Enter Invoice Number');
    }else{
      (async () => {
        const res = await postInvoiceNumber({rentalInvoice : rentalInvoice, leadId: parseInt(params.manageId), comm_id: parseInt(params.id)});
        if (res) {
          setIsModal(true);
        }
      })();
    }
    
  };

  useEffect(() => {
    if(Object.keys(contractData).length == 0){
      if(params.leadId == 1){
        (async () => {
          await contractCorporate(params);
          setContractData(contractCorpData);
        })();
      }else if(params.leadId == 2){
        (async () => {
          await contractApartment(params)
          setContractData(contractAptData);
        })();
      }else{
        (async () => {
          await contractSupply(params);
          setContractData(contractSupplyData);
        })();
      }
    }
  }, [contractData]);

  // console.log(postApartmentData.leadStatus);

  const handleButtons = () => {
    return (
      <Fragment>
        <Button className="btn btn-transparent hidden">{localization.save}</Button>
        {
          (rentalInvoice !== null && rentalInvoice !== '' && rentalInvoice !== undefined) && <>
            <Button onClick={() => handleSubmit(params.id)} /* disabled={isClicked} */>
              {localization.submitDtl} <Image fluid src={Images?.ArrowRight} />
            </Button>
          </>
        }
      </Fragment>
    );
  };
  function refreshPage() {
    window.location.reload(false);
  }
  
  return (
    <Layout
      history={history}
      Buttons={handleButtons}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
      title={localization.addInvoiceNumber}
    >
      
      <div className="row">
        <div className="col-md-12">
          
      {(contractData && contractData.lead_data) ? 
        <div className="panel-card card-details">
        <div className="panel-heading">{localization.leadDetails}</div>
        <div className="panel-body">
          <div className="details-listing detail_alignment">
           
                <DivLayout
                  heading={localization.leadNumber}
                  data={
                    contractData.lead_data?.lead_no
                      ? contractData.lead_data.lead_no
                      : localization.na
                  }
                />
                 <DivLayout
                  heading={localization.siteNumber}
                  data={
                    contractData.lead_data?.site_no
                      ? contractData.lead_data.site_no
                      : localization.na
                  }
                />
                <DivLayout
                    heading={localization.clientName}
                    data={
                      contractData.lead_data?.client_name
                        ? contractData.lead_data.client_name
                        : localization.na
                    }
                  />
            </div>
        </div>
        </div>
      : null}

{(contractData && contractData.postsale_data && contractData.postsale_data.commercial.manual_invoice ) ? 
        <div className="panel-card card-details">
        <div className="panel-heading">{localization.manualInvoice}</div>
        <div className="panel-body">
          <div className="details-listing detail_alignment">
          
            <DivLayout
                  heading={`Installation`}
                  data={
                    contractData.postsale_data.commercial.manual_invoice.installation_check
                      ? contractData.postsale_data.commercial.manual_invoice.installation_check
                      : localization.na
                  }
                />
                 <DivLayout
                  heading={`Tag`}
                  data={
                    contractData.postsale_data.commercial.manual_invoice.tag_check
                      ? contractData.postsale_data.commercial.manual_invoice.tag_check
                      : localization.na
                  }
                />
                <DivLayout
                    heading={`Rental/Capex`}
                    data={
                      contractData.postsale_data.commercial.manual_invoice.rental_check
                        ? contractData.postsale_data.commercial.manual_invoice.rental_check
                        : localization.na
                    }
                  />
                {contractData.postsale_data.commercial.manual_invoice.rental_check ==='Yes' ? 
                    <ConstantInput
                    label={`Rental Invoice Number`}
                    
                    type="text"
                    // value={locationData.billGeoState}
                    handleChange={(val) => {
                      setRentalInvoice(val);
                    }}
                    value={contractData.postsale_data.commercial.manual_invoice.rental_invoice_number ? contractData.postsale_data.commercial.manual_invoice.rental_invoice_number : ''}
                />
                :
                null}
            </div>
            </div>
            </div>

          : null}
      </div>
            </div>
            <ModalPop
                title={localization.conf}
                show={isModal}
                handleModalHide={handleModalHide}
                keyboard
              >
                <div className="text-center">
                  <div className="success">
                    <img src={Images?.tick} alt="" />
                  </div>
                  <h5>{localization.invoiceSuccess}</h5>
                  <Link
                    to={`${baseUrl}/approved-sales-listing`}
                    className="btn btn-primary mb-4"
                  >
                    {localization.postSales} <img src={Images?.ArrowRight} alt="" />
                  </Link>
                 
                </div>
              </ModalPop>
    </Layout>
  );
};

AddInvoiceNumber.propTypes = {
  history: propTypes.any,
};

export default AddInvoiceNumber;
